import React from "react";
import ButtonLink from "@streeteasy/design-system/deprecated/actions/button-link";
import { PrimaryMedium } from "@streeteasy/design-system/typography";

import * as S from "./styled";

export default function RentBuySellBlocks() {
  const handleAnalyticsButtonClick = eventAction => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: eventAction,
      event_label: "click"
    });
  };

  return (
    <>
      <S.SectionCardContainer>
        <S.SectionCardCopyContainer>
          <PrimaryMedium as="h2">Rent a NYC apartment</PrimaryMedium>
          <S.SectionCardBody as="div">
            Shop the city’s{" "}
            <S.TooltipWrapper
              position="top"
              theme="small"
              trigger="click"
              triggerNode={<S.Dashed>most trusted</S.Dashed>}
            >
              StreetEasy was described as trustworthy by more renters than other
              real estate platforms, according to a survey conducted by YouGov
              from June 7 to June 30, 2021, on a representative sample audience
              from 89 NYC zip codes.
            </S.TooltipWrapper>{" "}
            source of rental listings, filtering for the features you want most.
          </S.SectionCardBody>
        </S.SectionCardCopyContainer>
        <S.SectionCardButtonContainer>
          <ButtonLink
            href="/for-rent/nyc"
            onClick={() => handleAnalyticsButtonClick("search_rentals")}
          >
            Search Rentals
          </ButtonLink>
        </S.SectionCardButtonContainer>
      </S.SectionCardContainer>
      <S.SectionCardContainer>
        <S.SectionCardCopyContainer>
          <PrimaryMedium as="h2">Buy with confidence</PrimaryMedium>
          <S.SectionCardBody as="div">
            Find your NYC dream home and match with an&nbsp;
            <S.TooltipWrapper
              position="top"
              theme="small"
              trigger="click"
              triggerNode={<S.Dashed>Expert Agent</S.Dashed>}
            >
              Experts are licensed real estate agents from partner brokerages
              with verified experience in the areas you’re searching. StreetEasy
              earns a referral fee from Experts’ transactions, at no cost to
              you.
            </S.TooltipWrapper>
            &nbsp;who can help you navigate the buying process.
          </S.SectionCardBody>
        </S.SectionCardCopyContainer>
        <S.SectionCardButtonContainer>
          <ButtonLink
            href="/for-sale/nyc"
            onClick={() => handleAnalyticsButtonClick("search_sales")}
          >
            Search Sales
          </ButtonLink>
        </S.SectionCardButtonContainer>
      </S.SectionCardContainer>
      <S.SectionCardContainer>
        <S.SectionCardCopyContainer>
          <PrimaryMedium as="h2">Sell your home successfully</PrimaryMedium>
          <S.SectionCardBody as="div">
            Track its estimated value, and match with a trusted agent from
            our&nbsp;
            <S.TooltipWrapper
              position="top"
              theme="small"
              trigger="click"
              triggerNode={<S.Dashed>Experts network</S.Dashed>}
            >
              Experts are licensed real estate agents from partner brokerages
              with verified experience in the areas you’re searching. StreetEasy
              earns a referral fee from Experts’ transactions, at no cost to
              you.
            </S.TooltipWrapper>
            &nbsp;when it’s time to list.
          </S.SectionCardBody>
        </S.SectionCardCopyContainer>
        <S.SectionCardButtonContainer>
          <ButtonLink
            href="/sell-your-home"
            onClick={() => handleAnalyticsButtonClick("sell_homepage")}
          >
            See seller tools
          </ButtonLink>
        </S.SectionCardButtonContainer>
      </S.SectionCardContainer>
    </>
  );
}
